import { CorptaxBrandColor } from '../CorptaxBrandColor';
import { ICorptaxTheme } from '../ICorptaxTheme';
import { CorptaxThemeCscBrandStyles } from './CorptaxThemeCscBrandStyles';
import { CorptaxThemeNotificationBadgeStyles } from './CorptaxThemeNotificationBadgeStyles';
import { CorptaxThemeToggleButtonStyles } from './CorptaxThemeToggleButtonStyles';
import { ICscBrandStyles } from './ICscBrandStyles';
import { INotificationBadgeStyles } from './INotificationBadgeStyles';
import { ISemanticSiteHeaderStyles } from './ISemanticSiteHeaderStyles';
import { IToggleButtonStyles } from './IToggleButtonStyles';

export class CorptaxThemeSiteHeaderStyles implements ISemanticSiteHeaderStyles {
    protected iconFontSize = 16;
    protected toggleButtonWidth = 42;
    protected borderBottom;

    protected contextualMenuListStyles = {
        list: {
            '.ms-ContextualMenu-item': {
                height: 'auto',
                paddingLeft: 5,
                paddingRight: 5,
                paddingBottom: 2,
                paddingTop: 2,
            },
            //portal bootstrap override
            '.ms-ContextualMenu-link:focus': {
                outline: 'transparent',
                textDecoration: 'none',
            },
            //portal bootstrap override
            '.ms-ContextualMenu-link:hover': {
                textDecoration: 'none',
            },
        },
    };

    constructor(
        protected theme: ICorptaxTheme,
        protected height: number
    ) {
        this.borderBottom = `3px solid ${this.theme.extendedPalette.accent}`;
        this.cscBrand = new CorptaxThemeCscBrandStyles(this.theme, this.height, this.toggleButtonWidth);
        this.toggleButtonStyles = new CorptaxThemeToggleButtonStyles(this.theme, this.height, this.toggleButtonWidth);
        this.notificationBadgeStyles = new CorptaxThemeNotificationBadgeStyles(this.theme);
    }

    notificationBadgeStyles: INotificationBadgeStyles;
    toggleButtonStyles: IToggleButtonStyles;
    cscBrand: ICscBrandStyles;

    get stackStyles() {
        return {
            root: {
                background: this.theme.palette.themePrimary,
                color: this.theme.semanticColors.primaryButtonText,
                borderBottom: this.borderBottom,
                minHeight: this.height,
            },
            inner: {
                maxWidth: '100%',
            },
        };
    }

    get corptaxBrand() {
        return {
            logoStyles: {
                height: '24px',
                marginTop: '4px',
            },
            logoColor: CorptaxBrandColor.White,
        };
    }

    get iconStyles() {
        return {
            root: { fontSize: this.iconFontSize },
        };
    }

    get contextualMenuStyles() {
        return {
            container: { borderBottom: this.borderBottom },
            ...this.contextualMenuListStyles,
        };
    }

    get customMenuItemContainer() {
        return { borderBottom: `1px solid ${this.theme.semanticColors.bodyDivider}` };
    }
}
